export default "__VITE_ASSET__BbPErP8I__"